import type { TransactionsSort } from '@shared/transactions-types';
import { TransactionsSortOptions } from '@shared/transactions-types';
import { useQueryParam } from '@luna/router';
import { isSortingEnabledForContext } from '@shared/transactions-utils';

const DEFAULT_SORT: TransactionsSort = 'MAIN_DATE_DESC';

interface Params {
    isGlobalSearch?: boolean;
}

interface Returned {
    sort: TransactionsSort;
    setSort?: (sort?: TransactionsSort) => void;
}

const isValidSortValue = (value: string): value is TransactionsSort =>
    Boolean(value) && TransactionsSortOptions.includes(value as TransactionsSort);

export const useTransactionsSort = ({ isGlobalSearch = false }: Params = {}): Returned => {
    const [sort, setSort] = useQueryParam('sort');

    const isSortingEnabled = isSortingEnabledForContext(isGlobalSearch);

    if (!isSortingEnabled) {
        return { sort: DEFAULT_SORT };
    }

    if (isValidSortValue(sort)) {
        return { sort, setSort };
    }

    return { sort: DEFAULT_SORT, setSort };
};
